import {axiosInstance} from "@/plugins/axios";
import {Sale, SaleFilter} from "@/modules/sale/types";

export async function getSale(id: string) {
  const response = await axiosInstance.get(`sales/${id}`);
  return response.data;
}

export async function getSales(payload: SaleFilter) {
  let url = `sales?start_date=${payload.start_date}&end_date=${payload.end_date}`;

  if (payload.limit) {
    url += `&limit=${payload.limit}&offset=${payload.offset}`;
  }

  if (payload.field === "CUSTOMER" && payload.search && payload.search !== "") {
    url += `&customer=${payload.search}`
  }

  if (payload.field === "PRODUCT" && payload.search && payload.search !== "") {
    url += `&product=${payload.search}`
  }

  const response = await axiosInstance.get(url);

  return response.data;

}

export async function saveSales(sales: Sale[]) {
  await axiosInstance.post(`sales/create_or_update_many`, {
    sales: sales
  });
}

export async function saveRawSales(sales: Sale[]) {
  await axiosInstance.post(`sales/raw/create_or_update_many`, {
    sales: sales
  });
}
